module.exports = __webpack_public_path__ + "static/media/gzbg.a644937c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/gzbg.jpg
// module id = 669
// module chunks = 2